module.exports = __webpack_public_path__ + "static/media/additional-1-292x300.292ced49.png";